export const ACCOUNT_LOGIN_ROUTE = "/account";
export const ACCOUNT_DASHBOARD_ROUTE = "/account/dashboard";
export const ACCOUNT_SCHEDULE_UPDATE_ROUTE = "/account/schedule-update";